// Firebase WEB config for project portal-75bc2.
// These values are public by design (they ship to the browser); they are NOT secrets.
// The server-side FCM credential (service account) lives only in Supabase secrets.
export const firebaseConfig = {
  apiKey: 'AIzaSyAeHplBl-K33C56UJBLFNb7ZoLpippcahc',
  authDomain: 'portal-75bc2.firebaseapp.com',
  projectId: 'portal-75bc2',
  storageBucket: 'portal-75bc2.firebasestorage.app',
  messagingSenderId: '259338271588',
  appId: '1:259338271588:web:3b0ac129d822d372bd1871',
};

// Public VAPID key (Cloud Messaging → Web Push certificates → Key pair).
export const VAPID_KEY = 'BH6lt-m_xRF08KFzTRYPxiM22rwxz9OXpsfouc3sJRvpvSjlWe3vQm69SebhjP3QrXKGEjbWyAZ8ziTaGSeLAko';
